/* NOIRLAB product comparisons and Finder: public Shopify data, no tracking. */
(() => {
  "use strict";
  const KEY = "noirlab.compare.v1", MAX=3;
  const clean = (s,n=400) => typeof s === "string" ? s.slice(0,n).trim() : "";
  const valid = h => /^[a-z0-9][a-z0-9-]{0,120}$/.test(h || "");
  const FIELDS = ["handle","title","vendor","image","model","control","connectivity","compatibility","power","material","water","dimensions","warranty"];
  const read = () => {
    try {const x=JSON.parse(sessionStorage.getItem(KEY)||"[]");
      return Array.isArray(x)?x.filter(p=>p&&valid(p.handle)).slice(0,MAX).map(p=>Object.fromEntries(FIELDS.map(f=>[f,clean(p[f],f==="image"?1000:400)]))):[];
    }catch{return [];}
  };
  const save = items => {try{sessionStorage.setItem(KEY,JSON.stringify(items.slice(0,MAX)));}catch{}};
  const make = (tag,cls,text) => {const el=document.createElement(tag);if(cls)el.className=cls;if(text!==undefined)el.textContent=text;return el;};
  const money = value => {const code=(window.Shopify?.currency?.active)||"PLN";try{return new Intl.NumberFormat("pl-PL",{style:"currency",currency:code}).format(Number(value)/100)}catch{return String((Number(value)/100).toFixed(2))+" "+code}};
  const imageUrl = value => {const s=clean(value,1100);return /^https:\/\/[^"'<>]+$/i.test(s)?s:/^\/\/[^"'<>]+$/.test(s)?"https:"+s:"";};
  let latest=0;
  const notice = message => {const n=document.querySelector("[data-nl-cmp-status]")||document.querySelector("[data-toast]");if(!n)return;n.textContent=message;if(n.hasAttribute("hidden")&&!n.hasAttribute("data-nl-cmp-status")){n.hidden=false;setTimeout(()=>n.hidden=true,5000)}};
  function sync(){
    const selection=read();
    document.querySelectorAll("[data-nl-compare-add]").forEach(btn=>{
      const selected=selection.some(p=>p.handle===btn.dataset.handle);
      btn.setAttribute("aria-pressed",String(selected));
      btn.textContent=selected?"✓ W porównaniu":"＋ Porównaj";
    });
    let bar=document.getElementById("nl-compare-bar");
    if(!bar){bar=make("div","nl-compare-bar");bar.id="nl-compare-bar";bar.setAttribute("role","status");document.body.appendChild(bar)}
    bar.replaceChildren();
    bar.hidden=selection.length===0;
    if(selection.length){
      bar.appendChild(make("span","","Porównujesz "+selection.length+" z "+MAX+" modeli"));
      const link=make("a","","Zobacz porównanie →");link.href="/pages/porownaj-modele";bar.appendChild(link);
    }
  }
  async function retrieve(handle){
    try{const r=await fetch("/products/"+encodeURIComponent(handle)+".js",{credentials:"same-origin",headers:{Accept:"application/json"}});
      if(!r.ok)return null;const data=await r.json();return data?.handle===handle?data:null;
    }catch{return null}
  }
  const rows=[
    ["Aktualna cena",p=>p.live?(p.live.price_min!==p.live.price_max?"Od ":"")+money(p.live.price_min):"Brak aktualnej ceny"],
    ["Dostępność",p=>p.live?(p.live.available?"Dostępny":"Niedostępny"):"Niepotwierdzona"],
    ["Marka",p=>p.live?.vendor||p.vendor],
    ["Model",p=>p.model],["Sterowanie",p=>p.control],["Łączność",p=>p.connectivity],
    ["Kompatybilność",p=>p.compatibility],["Zasilanie",p=>p.power],["Materiał",p=>p.material],
    ["Ochrona IP",p=>p.water],["Wymiary",p=>p.dimensions],["Gwarancja",p=>p.warranty]
  ];
  async function render(){
    const root=document.querySelector("[data-nl-compare-view]");if(!root)return;
    const box=root.querySelector("[data-nl-cmp-results]"),clear=root.querySelector("[data-nl-cmp-clear]");
    const selection=read();box.replaceChildren();clear.hidden=selection.length===0;
    if(!selection.length){box.hidden=true;notice("Nie masz zapisanych modeli do porównania. Wybierz produkty z katalogu lub skorzystaj z tabeli kryteriów poniżej.");return;}
    box.hidden=false;notice("Sprawdzamy aktualne ceny i dostępność.");
    const token=++latest;
    const products=await Promise.all(selection.map(async p=>Object.assign({},p,{live:await retrieve(p.handle)})));
    if(token!==latest)return;
    const wrap=make("div","nl-cmp-scroll");wrap.tabIndex=0;wrap.setAttribute("role","region");wrap.setAttribute("aria-label","Porównanie modeli");
    const table=make("table","nl-cmp-table"),caption=make("caption","","Porównanie "+products.length+" modeli");
    table.appendChild(caption);
    const head=make("thead"),headRow=make("tr");headRow.appendChild(make("th","","Cecha"));
    for(const p of products){
      const th=make("th","nl-cmp-product"),link=make("a","",p.live?.title||p.title||p.handle);
      link.href="/products/"+encodeURIComponent(p.handle);th.appendChild(link);
      const url=imageUrl(p.live?.featured_image||p.image);
      if(url){const img=document.createElement("img");img.src=url;img.alt="";img.loading="lazy";img.width=130;th.appendChild(img)}
      const del=make("button","nl-cmp-remove","Usuń model");del.type="button";del.dataset.nlCompareRemove=p.handle;th.appendChild(del);headRow.appendChild(th);
    }
    head.appendChild(headRow);table.appendChild(head);
    const body=make("tbody");
    for(const pair of rows){
      const tr=make("tr"),h=make("th","",pair[0]);h.scope="row";tr.appendChild(h);
      for(const p of products){let value="";try{value=pair[1](p)}catch{}tr.appendChild(make("td","",value||"Nie podano"))}
      body.appendChild(tr);
    }
    table.appendChild(body);wrap.appendChild(table);box.appendChild(wrap);
    notice("Porównujesz dane z kart produktów. Niepodane parametry nie są zastępowane przypuszczeniami.");
  }
  function initFinder(root=document){
    root.querySelectorAll("[data-nl-finder]").forEach(el=>{
      if(el.dataset.nlBound)return;el.dataset.nlBound="yes";
      const cat=el.querySelector("[data-nl-finder-category]"),budget=el.querySelector("[data-nl-finder-budget]"),stock=el.querySelector("[data-nl-finder-available]");
      const items=[...el.querySelectorAll("[data-nl-finder-item]")],count=el.querySelector("[data-nl-finder-count]");
      const more=el.querySelector("[data-nl-finder-more]"),empty=el.querySelector("[data-nl-finder-none]");
      let shown=8;
      function apply(){
        const filtered=items.filter(item=>{
          const categories=(item.dataset.categoryHandles||"").split(",").filter(Boolean);
          return (cat.value==="all"||categories.includes(cat.value))
            &&(budget.value==="all"||Number(item.dataset.price)<=Number(budget.value))
            &&(!stock.checked||item.dataset.available==="true");
        });
        items.forEach(item=>item.hidden=!filtered.includes(item)||filtered.indexOf(item)>=shown);
        if(count){
          const n=filtered.length;
          const form=n===1?"model":((n%10===2||n%10===3||n%10===4)&&(n%100<12||n%100>14)?"modele":"modeli");
          count.textContent="Znaleziono "+n+" "+form+" w przeglądanej części katalogu.";
        }
        if(more)more.hidden=filtered.length<=shown;
        if(empty)empty.hidden=filtered.length>0;
      }
      [cat,budget,stock].forEach(x=>x.addEventListener("change",()=>{shown=8;apply()}));
      more?.addEventListener("click",()=>{shown+=8;apply()});
      apply();
    });
  }
  document.addEventListener("click",ev=>{
    const btn=ev.target.closest?.("[data-nl-compare-add]");
    if(btn){
      ev.preventDefault();
      const item=Object.fromEntries(FIELDS.map(f=>[f,clean(btn.dataset[f],f==="image"?1000:400)]));
      if(!valid(item.handle))return;
      const list=read(),idx=list.findIndex(p=>p.handle===item.handle);
      if(idx>=0)list.splice(idx,1);
      else if(list.length===MAX){notice("Porównasz maksymalnie trzy modele. Usuń jeden z listy, aby dodać następny.");return}
      else list.push(item);
      save(list);sync();void render();return;
    }
    const del=ev.target.closest?.("[data-nl-compare-remove]");
    if(del){save(read().filter(p=>p.handle!==del.dataset.nlCompareRemove));sync();void render();return}
    if(ev.target.closest?.("[data-nl-cmp-clear]")){save([]);sync();void render()}
  });
  function init(){sync();void render();initFinder()}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
  document.addEventListener("shopify:section:load",e=>{sync();void render();initFinder(e.target)});
  window.addEventListener("pageshow",()=>{sync();void render()});
})();